//TODO : Refactor after ai
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

export interface AppShellProps extends HTMLAttributes<HTMLDivElement> {
  sidebar?: ReactNode;
  /**
   * Search sits centre-stage rather than in a corner, because in an
   * object-oriented back office people reach records by searching far more
   * often than by navigating.
   */
  search?: ReactNode;
  barLeft?: ReactNode;
  barRight?: ReactNode;
  children?: ReactNode;
  contentPadding?: number | string;
  style?: CSSProperties;
}

/** Application frame: sidebar, top bar with centred search, scrolling content. */
export function AppShell({
  sidebar,
  search,
  barLeft,
  barRight,
  children,
  contentPadding,
  className = "",
  style,
  ...rest
}: AppShellProps) {
  return (
    <div className={`bui-shell ${className}`} style={style} {...rest}>
      {sidebar}
      <div className="bui-shell__main">
        <header className="bui-shell__bar">
          <div className="bui-shell__bar-left">{barLeft}</div>
          {search && <div className="bui-shell__bar-center">{search}</div>}
          <div className="bui-shell__bar-right">{barRight}</div>
        </header>
        <div
          className="bui-shell__content"
          style={contentPadding != null ? { padding: contentPadding } : undefined}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
